module.exports = __webpack_public_path__ + "img/20180815_150609_095.733aed72.jpg";